import React from 'react';
import './Footer.scss';
const Footer = () => {
  return (
    <div className='footer_container'>
      <div className='line'>
        <div className='dot left'></div>
        <div className='dot right'></div>
      </div>
      {/* <div className='social_links'>
        <a href='https://twitter.com/0xmercle' target='_blank'>
          Twitter
        </a>
        <a href='https://backend.mercle.xyz/misc/mercleDiscordInvite' target='_blank'>
          Discord
        </a>
      </div> */}
      <div className='footer_line'>
        LOVING MERCLE? WE’RE ALWAYS DISCUSSING WHATEVER WE’RE COOKING HERE -{' '}
        <a href='https://backend.mercle.xyz/misc/mercleDiscordInvite' target='_blank'>
          DISCORD
        </a>
      </div>
    </div>
  );
};

export default Footer;
